import { MidHeading, Text } from '@propertypal/web-ui/src/typography';
import React from 'react';
import {
  Container,
  Box,
  BoxesRow,
  PhonesImage,
  Boxes,
  PhonesImageMobile,
  PhonesImageMobileBox,
  MobileBoxes,
} from './FeatureBoxesSection.style';

const FeatureBoxesSection = () => {
  return (
    <Container>
      <Boxes>
        <PhonesImageMobileBox>
          <PhonesImageMobile />
        </PhonesImageMobileBox>

        <MobileBoxes>
          <Box>
            <MidHeading fontSize={22}>Real-time updates</MidHeading>
            <Text maxWidth={290}>
              Never miss a new listing, with instant email alerts on properties that are fresh on the market.
            </Text>
          </Box>
          <Box>
            <MidHeading fontSize={22}>Favourites</MidHeading>
            <Text maxWidth={290}>
              A wishlist for all the properties you love to help keep track of any price or status changes all in one
              place.
            </Text>
          </Box>
          <Box>
            <MidHeading fontSize={22}>Draw a search</MidHeading>
            <Text maxWidth={290}>
              Simply draw around your favourite areas, so you can pinpoint exactly where you want to live.{' '}
            </Text>
          </Box>
          <Box>
            <MidHeading fontSize={22}>Most property listings in NI</MidHeading>
            <Text maxWidth={290}>
              As NI&apos;s favourite property portal, we have more properties than any other portal in NI.
            </Text>
          </Box>
        </MobileBoxes>

        <BoxesRow>
          <Box>
            <MidHeading fontSize={22}>Real-time updates</MidHeading>
            <Text maxWidth={290}>
              Never miss a new listing, with instant email alerts on properties that are fresh on the market.
            </Text>
          </Box>
          <Box>
            <MidHeading fontSize={22}>Favourites</MidHeading>
            <Text maxWidth={290}>
              A wishlist for all the properties you love to help keep track of any price or status changes all in one
              place.
            </Text>
          </Box>
        </BoxesRow>
        <BoxesRow>
          <Box>
            <MidHeading fontSize={22}>Draw a search</MidHeading>
            <Text maxWidth={290}>
              Simply draw around your favourite areas, so you can pinpoint exactly where you want to live.{' '}
            </Text>
          </Box>
          <Box>
            <MidHeading fontSize={22}>Most property listings in NI</MidHeading>
            <Text maxWidth={290}>
              As NI&apos;s favourite property portal, we have more properties than any other portal in NI.
            </Text>
          </Box>
        </BoxesRow>
        <PhonesImage />
      </Boxes>
    </Container>
  );
};

export default FeatureBoxesSection;
